import { render, staticRenderFns } from "./PreferredRegionSummary.vue?vue&type=template&id=79b34ac2"
import script from "./PreferredRegionSummary.vue?vue&type=script&lang=js"
export * from "./PreferredRegionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports